import React from 'react';
import { Modal, Box } from '@mui/material';

const ImageModal = ({ src, open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          bgcolor: 'rgba(0, 0, 0, 0.8)',
        }}
        onClick={onClose} // Close modal on background click
      >
        <img
          src={src}
          alt="Fullscreen"
          style={{
            maxHeight: '90%',
            maxWidth: '90%',
            objectFit: 'contain',
          }}
        />
      </Box>
    </Modal>
  );
};

export default ImageModal;
